'use strict';

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var pkgversion = require('../../../package.json').version;

var multiaddr = require('multiaddr');

var _require = require('../utils'),
    withTimeoutOption = _require.withTimeoutOption;

module.exports = function (_ref) {
  var peerInfo = _ref.peerInfo,
      libp2p = _ref.libp2p;
  return withTimeoutOption( /*#__PURE__*/function () {
    var _id = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var id, addresses;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              // eslint-disable-line require-await
              id = peerInfo.id.toB58String();
              addresses = [];

              if (libp2p) {
                // only available while the node is running
                addresses = libp2p.transportManager.getAddrs();
              }

              return _context.abrupt("return", {
                id: id,
                publicKey: peerInfo.id.pubKey.bytes.toString('base64'),
                addresses: addresses.map(function (ma) {
                  var str = ma.toString(); // some relay-style transports add our peer id to the ma for us
                  // so don't double-add

                  if (str.endsWith("/p2p/".concat(id))) {
                    return str;
                  }

                  return "".concat(str, "/p2p/").concat(id);
                }).sort().map(function (ma) {
                  return multiaddr(ma);
                }),
                agentVersion: "js-ipfs/".concat(pkgversion),
                protocolVersion: '9000'
              });

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    function id() {
      return _id.apply(this, arguments);
    }

    return id;
  }());
};